<div id="lesson">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-3" *ngIf="showSideMenu">
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>Functional MOUs</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li routerLinkActive="active">
                            <a routerLink="/research/mou/2025-2026" (click)="checkRoute()">2025-2026</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/research/mou/2024-2025" (click)="checkRoute()">2024-2025</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/research/mou/2023-2024" (click)="checkRoute()">2023-2024</a>
                        </li>
                        <li routerLinkActive="active">
                            <a routerLink="/research/mou/2022-2023" (click)="checkRoute()">2022-2023</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>